/* @flow */
import ExifOrientationImg from './ExifOrientationImg';

export default ExifOrientationImg;
